<template>
  <evaluate-container :list="questions" :answers="answers" :all="all" :tree="tree" :is-view="isView" :role="role" :info="info" :find-answer="findAnswer" :node-click="handleNodeClick">
    <template v-slot:default="{list, current, currentForm, currentIndex, indexChange, upload, down}">
      <el-form ref="form" :model="currentForm">
        <h2>
          {{ current.name }}
        </h2>
        <p class="text-red-600 text-xs">在满足低等级后，才可以继续选择下一级别。</p>
        <div class="space-y-5">
          <div class="flex items-center space-x-5 max-w-md lg:max-w-xl xl:max-w-4xl 2xl:max-w-6xl" v-for="(item, index) in current.children" :key="`${currentForm.quesId}-${index}`">
            <el-checkbox :disabled="index > 0 && currentForm.ans.length < index" :value="currentForm.ans.length > index" @change="val => handleCheckChange(currentForm, item, val, index)"></el-checkbox>
            <el-card>
              <div class="flex justify-between space-x-2">
                <span class="bg-blue-300 rounded text-xs p-2 flex-none self-start">{{ ['一', '二', '三', '四'][index] }}级</span>
                <p class="w-screen">{{ item.name }}</p>
              </div>
            </el-card>
          </div>
        </div>
        <div>
          <el-form-item prop="fileIds">
            <el-button :disabled="currentIndex === 0" @click="indexChange(currentIndex - 1)">回到上一题</el-button>
            <el-button v-if="!isView" @click="handleSave(currentForm)" :disabled="currentForm.saved">保存</el-button>
            <el-button :disabled="currentIndex + 1 === list.length" @click="indexChange(currentIndex + 1)">进入下一题</el-button>
            <el-button v-if="currentIndex + 1 === questions.length" @click="handleChangeType">查看进度</el-button>
          </el-form-item>
        </div>
      </el-form>
    </template>
  </evaluate-container>
</template>

<script>
import EvaluateContainer from '@/views/proposal/partials/EvaluateContainer'
import { addOwnerSceneAnswer as addAnswer } from '@/api/enterprise'

export default {
  props: ['info', 'questions', 'answers', 'all', 'tree', 'isView', 'role', 'mode'],
  components: { EvaluateContainer },
  data () {
    return {
      rules: {
        fileIds: {
          validator: (rule, value, cb) => {}
        },
        remark: { required: true, message: '谰审意见不能为空', trigger: 'blur' }
      },
      pivotForm: {}
    }
  },
  mounted () {
    if (!this.info.declarationId && !this.answers.length) {
      this.$confirm('企业可自行选择所涉及的数字化场景，不涉及的可跳过不填。完成填报后可提交问卷！', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false
      }).then(() => {}).catch(() => {})
    }
  },
  methods: {
    findAnswer (v) {
      const item = this.answers.find(a => a.quesId * 1 === v.id * 1) || { quesId: v.id * 1, ans: '[]', fileIds: '[[],[],[],[]]', version: 1, otherAns: '{}' }
      return Object.assign({}, item, { ans: JSON.parse(item.ans), otherAns: JSON.parse(item.otherAns), fileIds: JSON.parse(item.fileIds) })
    },
    handleSave (currentForm) {
      const data = {
        quesId: currentForm.quesId,
        ans: JSON.stringify(currentForm.ans),
        otherAns: JSON.stringify(currentForm.otherAns),
        fileIds: JSON.stringify(currentForm.fileIds),
        userId: this.info.userId,
        version: 1
      }
      addAnswer(data).then(res => {
        this.$set(currentForm, 'id', res.data.id)
        currentForm.saved = true
        this.$message.success('保存成功！')
        this.$emit('save', res.data)
      })
    },
    handleCheckChange (currentForm, item, val, index) {
      if (val) {
        currentForm.ans.push(item.id)
      } else {
        currentForm.ans.splice(index, currentForm.ans.length)
      }

      currentForm.saved = false
    },
    handleNodeClick (node) {
      if (node.level === 2) {
        return this.questions.findIndex(v => v.id === node.id)
      } else return -1
    },
    handleChangeType () {
      this.$emit('change-type', '')
    }
  }
}
</script>
